<template>
<div class="chapter">
<div class="inner_page">
<div class="toc1"><p class="toc"><span><b>CONTENTS</b></span></p></div>
<div class="toc1">
<p class="toc"><a href="#/Book1/cover">The Wrong Box</a></p></div>
<p class="toc"><a href="#/Book1/Untitled1">Title Page</a></p>
<p class="toc"><a href="#/Book1/introduction">Introduction</a></p>
<p class="toc"><a href="#/Book1/Untitled11">Preface</a></p>
<p class="toc"><a href="#/Book1/Untitled12">Chapter I: In Which Morris Suspects</a></p>
<p class="toc"><a href="#/Book1/Untitled13">Chapter II: In Which Morris Takes Action</a></p>
<p class="toc"><a href="#/Book1/Untitled14">Chapter III: The Lecturer at Large</a></p>
<p class="toc"><a href="#/Book1/Untitled15">Chapter IV: The Magistrate in the Luggage Van</a></p>
<p class="toc"><a href="#/Book1/Untitled16">Chapter V: Mr. Gideon Forsyth and the Gigantic Box</a></p>
<p class="toc"><a href="#/Book1/Untitled17">Chapter VI: The Tribulations of Morris: Part the First</a></p>
<p class="toc"><a href="#/Book1/Untitled18">Chapter VII: In Which William Dent Pitman takes Legal Advice</a></p>
<p class="toc"><a href="#/Book1/Untitled19">Chapter VIII: In Which Michael Finsbury Enjoys a Holiday</a></p>
<p class="toc"><a href="#/Book1/Untitled110">Chapter IX: Glorious Conclusion of Michael Finsbury’s Holiday</a></p>
<p class="toc"><a href="#/Book1/Untitled111">Chapter X: Gideon Forsyth and the Broadwood Grand</a></p>
<p class="toc"><a href="#/Book1/Untitled112">Chapter XI: The Maestro Jimson</a></p>
<p class="toc"><a href="#/Book1/Untitled113">Chapter XII: Positively the Last Appearance of the Broadwood Grand</a></p>
<p class="toc"><a href="#/Book1/Untitled114">Chapter XIII: The Tribulations of Morris: Part the Second</a></p>
<p class="toc"><a href="#/Book1/Untitled115">Chapter XIV: William Bent Pitman Hears of Something to his Advantage</a></p>
<p class="toc"><a href="#/Book1/Untitled116">Chapter XV: The Return of the Great Vance</a></p>
<p class="toc"><a href="#/Book1/Untitled117">Chapter XVI: Final Adjustment of the Leather Business</a></p>
<div class="toc1">
<p class="toc"><span href="#/Book2/cover" title="Link target outside of Sample">The Body Snatcher</span></p></div>
<p class="toc"><a href="#/Book2/Untitled1">Title Page</a></p>
<p class="toc"><span href="#/Book2/introduction" title="Link target outside of Sample">Introduction</span></p>
<p class="toc"><a href="#/Book2/Untitled11">The Body Snatcher</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?f6aa28b6